/**
 * GelatoMaps — Event Bus
 * For ephemeral cross-module communication (actions, not state).
 *
 * Naming: {domain}:{action-past-tense}
 * Examples: map:shop-focused, ranking:item-clicked, panel:opened
 * @module events
 */

/** @type {Map<string, Set<Function>>} */
const _handlers = new Map()

export const bus = {
  /**
   * Emit an event.
   * @param {string} event - Event name (e.g., 'map:shop-focused')
   * @param {any} [data] - Event payload
   */
  emit(event, data) {
    const handlers = _handlers.get(event)
    if (handlers) {
      handlers.forEach(fn => {
        try { fn(data) } catch (e) { console.error(`[bus] handler error on '${event}':`, e) }
      })
    }
  },

  /**
   * Subscribe to an event.
   * @param {string} event
   * @param {Function} fn
   * @returns {Function} unsubscribe function
   */
  on(event, fn) {
    if (!_handlers.has(event)) _handlers.set(event, new Set())
    _handlers.get(event).add(fn)
    return () => _handlers.get(event).delete(fn)
  },

  /**
   * Subscribe to an event, auto-unsubscribe after first call.
   * @param {string} event
   * @param {Function} fn
   */
  once(event, fn) {
    const unsub = this.on(event, (data) => {
      unsub()
      fn(data)
    })
  },
}

// Expose for debugging
if (typeof window !== 'undefined') {
  window.__bus = bus
}
